<template>
  <b-overlay :show="show" rounded="sm">
    <template v-slot>
      <slot></slot>
    </template>
    <template v-slot:overlay>
      <div
        class="h-100 spinner d-flex flex-row
            justify-content-center align-items-center"
      >
        <scale-loader
          :loading="loading"
          :color="color"
          :height="height"
          :width="width"
        />
      </div>
    </template>
  </b-overlay>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

import chartColors from './chart_colors.js'

export default {
  name: 'CBusy',
  components: { ScaleLoader },
  props: ['show'],
  data() {
    return {
      loading: true,
      color: chartColors.blue,
      width: '64px',
      height: '64px',
    }
  },
}
</script>
